import { $, $$, insertHTML } from 'src/shared/js/utils/dom';
import WaterfallColumns from 'src/shared/js/modules/waterfall';
import { Lightbox } from '@3pc/lightbox-photoswipe/lib/index';

class Grid {
  BREAKPOINT = 767;

  constructor(props) {
    this.container = props.container;
    this.waterfall = false;
    this.lightbox = false;
  }

  init = () => {
    this.appendRatioPlaceholder();
    this.initWaterFall();
  };

  appendRatioPlaceholder = () => {
    const items = $$('.image-gallery__item', this.container);
    const template = `<span class="image-gallery-placeholder"></span>`;

    items.forEach(item => {
      const lightbox = $('.image-gallery__lightbox-toggle', item);
      insertHTML(lightbox, 'beforeend', template);
    });
  };

  updateGrid() {
    this.waterfall.updateWaterfall();
  }

  initLightBox = () => {
    this.lightbox = new Lightbox({
      gallery: this.container,
      children: $$('.image-gallery__lightbox-toggle', this.container),
      padding: {
        top: 120,
        bottom: 120,
      },
    });

    this.lightbox.init();
  };

  initWaterFall = () => {
    this.initLightBox();

    const sizes = [
      { columns: 1, gutter: 15 },
      { mq: '768px', columns: 3, gutter: 0 },
    ];

    this.waterfall = new WaterfallColumns({
      container: $('.image-gallery__wrapper', this.container),
      items: $$('.image-gallery__item', this.container),
      mediaQueries: sizes,
    });

    this.waterfall.init();
  };
}

const galleryGrid = $$('.image-gallery__grid');

galleryGrid.length &&
  galleryGrid.forEach(gallery => {
    const grid = new Grid({
      container: gallery,
    });

    grid.init();
  });
